import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { AvatarRoot } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AvatarRoot), {
    "data-slot": "avatar",
    class: _normalizeClass(
            _unref(cn)(
                'bg-background inline-flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border align-middle select-none',
                props.class,
            )
        )
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})